var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"productDetail_wrap"},[_c('div',{staticClass:"productDetail_item",domProps:{"innerHTML":_vm._s(_vm.richTextContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }